import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import Logo from '../assets/img/ibridge-logo-blue.svg';
import CircleIcon from '../assets/img/Icon.svg';
import NotificationIcon from '../assets/img/notification-icon.svg';
import UserIcon from '../assets/img/user-icon.svg';
import ProfileIcon from '../assets/img/profile-icon.svg';
import VideoIcon from '../assets/img/video-icon.svg';
import FlagIcon from '../assets/img/flag-icon.svg';
import PrivacyIcon from '../assets/img/privacy-icon.svg';
import "../assets/css/authorization.css";
import RSPLLogo from '../assets/img/RSPL-Logo-1.png';

import '../assets/css/header.css';
import { getData } from "../Actions/landingAction";
import { useDispatch, useSelector } from "react-redux";
import { getLogout } from '../Actions/logoutAction';
import { useNavigate } from "react-router-dom";
import dummyLogo from '../assets/img/LOGO.svg';
const Header = ({url})=> {
  let navigate = useNavigate();
  const storeLogoutData = useSelector((state) => state.logout);
  const { logoutData, loading, error } = storeLogoutData;
  const [isDigitalArn,setIsDigitalArn] = useState(0);
  const [name,setName]=useState();

  let clientId;
  let userData1 = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  if(userData1 && (userData1?.client_id || userData1?.bridge_client_id)){
    clientId = userData1?.client_id || userData1?.bridge_client_id;  
  }

  useEffect(()=>{
    if (typeof logoutData !== "undefined" && logoutData !== null) {
      if (logoutData.status === "success") {
        
        window.location.href = 'login';
      }
    }
  },[storeLogoutData]);

  const dispatch = useDispatch();
const logoutHandler=()=>{
  dispatch(getLogout());
  //localStorage.clear('userVerificationCandidate');
} 

const storeOtpArnData = useSelector((state) => state.verifyOtpArn);
const { otpArnData, load, err } = storeOtpArnData;

  const [firstName, setfirstName] = useState();
  const storeLandingData = useSelector((state) => state.landingPage);
  
  const { Data, loadingData, errorData } = storeLandingData;
  useEffect(() => {
    if (typeof Data?.data !== "undefined" && Data?.data !== null) {

      setfirstName(Data.data.candidate.candidate_first_name);
    }
  }, [Data, storeLandingData]);

 // console.log(firstName);
	
  useEffect(() => {
    let userVerif=JSON.parse(localStorage.getItem('userVerification'));
    setIsDigitalArn(userVerif?.is_digital_arn_candidate);
    setName(userVerif?.username);
    const pageData = async () => {
      dispatch(getData());
    };

    pageData();
  }, []);

    return (
      <>

      <header className="bg-blue">
        <nav className="navbar navbar-expand-lg navbar-light" style={{marginTop: `${clientId == "467104" ? '-10px' : "2px"}`}}>
         {isDigitalArn == 1 ?  <Link  className="navbar-brand ml-4">
            <img
              className=''
              // style={{marginTop: '-20px'}}
              // style={{marginTop: `${clientId == "467104" ? '-20px' : "2px"}`}}
              src={Logo} 
            />
            {clientId == "467104" &&
            <img src={RSPLLogo} className="ml-2" 
            style={{height: 55, marginTop: -2}} 
            />
            }
          </Link> : <Link to={url || "/dashboard"} className="navbar-brand ml-4">

            <img src={Logo} className='' style={{marginTop: -`${clientId == "467104" ? '-10px' : ""}`}} />

            {clientId == "467104" &&
            <img src={RSPLLogo} className="ml-2 mb-0" 
            style={{height: 55, marginTop: -2}} 
            />
            }
          </Link> }

          {/* <div className='gray_logo'><img src={dummyLogo}/></div> */}
          
            <ul className="navbar-nav ml-auto user-menu">
              <li className="nav-item">
                <Link to="">
               {/*   <img src={CircleIcon} alt=""/>    */}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="">
          {/*        <img src={NotificationIcon} alt=""/>   */}
                </Link>
              </li>
              <li className="nav-item mr-2" id="navbarDropdown" role="button" data-toggle="dropdown">
                <Link to="#" className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <img src={UserIcon} alt="" className="mr-3" />
                  <span className="user-welcome-txt">Hi {firstName || name}</span>
                </Link>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <span className="dropdown-menu-btn-box">
                    <button className="btn btn-danger btn-block"  onClick={logoutHandler}>Log out</button>
                  </span>

                </div>  
              </li>
              {/* <li className="nav-item dropdown" id="navbarDropdown" role="button" data-toggle="dropdown">
                <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  
                </Link>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton"> */}

                 {/* <h6 className="dropdown-header mb-2">Resources</h6>

                  <Link className="dropdown-item d-flex align-items-center" to="#">
                    <img src={ProfileIcon} alt="" className="mr-3" />
                    My Profile
                  </Link>
                  <Link className="dropdown-item d-flex align-items-center" to="#">
                    <img src={VideoIcon} alt="" className="mr-3" />
                    Video Tutorial
                  </Link>

                  <h6 className="dropdown-header mb-2">Company</h6>

                  <Link className="dropdown-item d-flex align-items-center" to="#">
                    <img src={FlagIcon} alt="" className="mr-3" />
                    About Authbridge
                  </Link>
                  <Link className="dropdown-item d-flex align-items-center" to="#">
                    <img src={PrivacyIcon} alt="" className="mr-3" />
                    Privacy Policy
                     </Link>     */}

                  {/* <span className="dropdown-menu-btn-box">
                    <button className="btn btn-danger btn-block"  onClick={logoutHandler}>Log out</button>
                  </span>

                </div>       */}
              {/* </li> */}
            </ul>
        </nav>
      </header>
      </>
    );
}
export default Header;